import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import useTranslator from "../../hooks/useTranslator";
import { convertCurrencyFormat } from "../../helper/common";

const CustomIncomeSourceCard = ({
  userId,
  sourceKey,
  selectedSource = [],
  changeSelectedSource,
  title,
  amount,
  hasDuplicateTitle,
  onTitleChange,
  onAmountChange,
  onRemove,
}) => {
  const { _t } = useTranslator();
  const isActive = selectedSource?.includes(sourceKey);

  const monthlyAmount =
    Number(amount) > 0 ? convertCurrencyFormat(Number(amount)) : "0";

  return (
    <div
      className={`income-source-card-wrapper custom-income-source-card ${
        isActive ? "income-source-card-wrapper-active" : ""
      }`}
      onClick={() => changeSelectedSource(userId, sourceKey)}
      style={{ position: "relative" }}
    >
      <div className="d-flex align-items-center about-source custom-income-source-content">
        <div className="default-checkbox d-flex align-items-center justify-content-center">
          {isActive && <CheckOutlinedIcon />}
        </div>
        <div className="d-flex flex-column flex-1 w-100">
          <div
            className="custom-income-source-card-fields"
            onClick={(e) => e.stopPropagation()}
          >
            <input
              type="text"
              className={`custom-income-title-input ${
                hasDuplicateTitle ? "custom-income-input-error" : ""
              }`}
              placeholder={_t("customIncomeTitle", "Income source title")}
              value={title}
              onChange={(e) => onTitleChange(e.target.value)}
            />
            <div className="custom-income-amount-wrapper">
              <input
                type="number"
                className="custom-income-amount-input"
                placeholder={_t("customIncomeAmount", "Monthly amount")}
                value={amount}
                onChange={(e) => onAmountChange(e.target.value)}
                min="0"
              />
              <span className="custom-income-amount-suffix">€/{_t("mo")}</span>
            </div>
          </div>
          {hasDuplicateTitle && (
            <span className="custom-income-error-text">
              {_t(
                "duplicateIncomeTitle",
                "An income source with this title already exists"
              )}
            </span>
          )}
        </div>
      </div>
      <ClearOutlinedIcon
        className="custom-income-remove-btn"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      />
    </div>
  );
};

export default CustomIncomeSourceCard;
